export default __webpack_public_path__ + "static/0152-25ff9fd3f23cb4826a1f30d0e2eef570.png";